import { mapGetters } from 'vuex';

import Multiselect from 'vue-multiselect';

import errorComments from '@/components/errorComments/index.vue';

import Api from '@/utils/api';

import {
  ROLE_SYSTEM_ADMIN,
  ROLE_QA_EXPERT,
  ROLE_PROOF_READER,
  ROLE_LSP,
} from '@/utils/const';

export default {
  name: 'ReportErrorsItem',
  components: {
    Multiselect,
    errorComments,
  },
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    report: {
      type: Object,
      default: () => {},
    },
    selectCategory: {
      required: true,
    },
    selectSeverity: {
      required: true,
    },
    selectMetarule: {
      required: true,
    },
    paginationPrm: {
      required: true,
    },
    currentIx: {
      required: true,
    },
  },
  data () {
    return {
      defaultErrorCategoryID: {},
      defaultSeverity: {},
      defaultMetaruleID: {},
      showCorrection: false,
      showErrorInfo: false,
      showTarget: false,
      showSource: false,
      showComment: false,
      showNote: false,
      actiualErrorWeight: 0,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
      userRole: 'userRole',
    }),
    checkRole () {
      if (this.userRole === ROLE_SYSTEM_ADMIN ||
          this.userRole === ROLE_QA_EXPERT ||
          this.userRole === ROLE_PROOF_READER) {
        return true;
      }
      return false;
    },
    abilityChangeError () {
      if (this.$store.getters.userRole === ROLE_SYSTEM_ADMIN ||
                this.$store.getters.userRole === ROLE_QA_EXPERT) {
        return true;
      }
      return false;
    },
  },
  created () {
    this.createDefaultSelects();
    this.actulalErrorWeight();
  },
  methods: {

    /**
         * Method for finde property
         *
         * @param {Number} id
         * @param {String} type
         */
    getPropertyData (id, type) {
      switch (type) {
      case 'category':
        if (this.report.FilterData.ErrorCategories.find((item) => item.ID === id) !== undefined) {
          return this.report.FilterData.ErrorCategories.find((item) => item.ID === id).Name;
        }
        break;
      case 'severity':
        if (this.report.FilterData.Severities.find((item) => item.ID === id) !== undefined) {
          return this.report.FilterData.Severities.find((item) => item.ID === id).Name;
        }
        break;
      case 'metarule':
        if (this.report.FilterData.Metarules.find((item) => item.CodeId === id) !== undefined) {
          return JSON.parse(this.report.FilterData.Metarules.find((item) => item.CodeId === id).Metarules);
        }
        break;
      default:
        break;
      }
    },

    /**
         * Method for update ko
         * @param {Object Vue} event
         */
    changeKo (event) {
      this.error.KOStatus = event.target.checked;
    },

    /**
         * Set default params in select
         */
    createDefaultSelects () {
      this.defaultErrorCategoryID = {};
      this.defaultSeverity = {};
      this.defaultMetaruleID = {};

      this.report.FilterData.ErrorCategories.forEach((item) => {
        if (this.error.ErrorCategoryID === item.ID) {
          this.defaultErrorCategoryID = {
            'id': item.ID,
            'name': item.Name,
          };
        }
      });

      this.report.FilterData.Metarules.forEach((item) => {
        if (this.error.MetaruleID === item.CodeId) {
          var jsonMetarules = JSON.parse(item.Metarules);
          var stringMetarules = '';

          jsonMetarules.forEach((val) => {
            stringMetarules += '<span>' + val.CodeName + '</span>';
          });

          this.defaultMetaruleID = {
            'id': item.CodeId,
            'name': stringMetarules,
          };
        }
      });

      this.report.FilterData.Severities.forEach((item) => {
        if (this.error.Severity === item.ID) {
          this.defaultSeverity = {
            'id': item.ID,
            'name': item.Name,
          };
        }
      });
    },

    /**
         * Define actual error weight
         */
    actulalErrorWeight () {
      const errorClass = this.report.ReportErrorClasses.find((c) => {
        if (c.ErrorCategoryID == this.error.ErrorCategoryID) { return c; }
      });
      this.actulalErrorWeight = !errorClass ? this.error.ErrorWeight : errorClass.CategoryWeight;
    },

    /**
         * Method for change error
         *
         * @param {Object} value
         * @param {Number} id
         * @param {String} type
         */
    changeErrorType (value, id, type) {
      if (this.error.ID == id) {
        this.error[type] = value.id;
        var severity = null;
        this.report.FilterData.ErrorClasses.forEach((itemError) => {
          if (itemError.ErrorCategoryID == this.error.ErrorCategoryID) {
            this.report.FilterData.Severities.forEach((itemSeverities) => {
              if (this.error.Severity == itemSeverities.ID) {
                severity = itemSeverities.Name;
              }
            });
            this.error.ErrorPoints = itemError[severity + 'ErrorPoints'];
          }
        });
      }
    },

    getErrorPoints (errorCatId, severity) {
      const errorClassEl = this.report.ReportErrorClasses.find((item) => {
        if (item.ErrorCategoryID === errorCatId) {
          return true;
        }
      });
      return severity.id === 2 ? errorClassEl.MinorErrorPoints : errorClassEl.MajorErrorPoints;
    },
    getDescription (errorCatId) {
      const errorCategory = this.selectCategory.filter((val) => {
        if (val.id == errorCatId) {
          return val;
        }
      });
      return errorCategory.length == 0 ? 'Error category not found!' : errorCategory[0].desc;
    },

    /**
         * Show popup
         */
    holderDeleteErrorItem () {
      this.$modal.show('dialog', {
        title: 'Warning!',
        text: 'Are you sure you`d lite delete this error item?',
        buttons: [
          {
            title: 'Yes',
            handler: () => {
              this.deleteErrorItem();
              this.$modal.hide('dialog');
            },
          },
          {
            title: 'No',
          },
        ],
      });
    },

    /**
         * Remove error item
         */
    deleteErrorItem () {
      Api.reports
        .deleteError(this.error.ID)
        .then((data) => {
          if (data.data.Status) {
            this.$root.$emit('notification', {
              message: 'Remove successful',
              type: 'info',
              show: true,
            });

            this.$emit('removeErrorItem', this.error.ID, data.data.SampleValue.Rating);
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
         * Update error item
         */
    updateItem () {
      Api.reports
        .updateErrorItem(this.error)
        .then((data) => {
          if (data.data.Status) {
            this.$emit('updateErrorItem', {
              rating: data.data.Data.Rating,
              ko: data.data.Data.KOStatus,
              type: data.data.Data.ReportType,
              metarules: data.data.Data.UsedMetarules,
            });

            this.showErrorInfo = !this.showErrorInfo;

            this.$root.$emit('notification', {
              message: 'Update successful!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.SystemMessage,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
         * Save correction text
         */
    saveField (valueName) {
      Api.reports
        .correctionUpdate(this.error)
        .then((data) => {
          if (data.data.Status) {
            this.$root.$emit('notification', {
              message: 'Update successful',
              type: 'info',
              show: true,
            });
            this[valueName] = false;
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
         * Method for change comment counts
         */
    addComment () {
      this.error.HasComments = true;
      this.error.Notes++;
      this.error.Commentators = [];
      this.error.Commentators.push(this.user.UserId);
    },

    /**
         * Method for change comment counts
         */
    removeComment () {
      this.error.HasComments = false;
      this.error.Notes--;
      if (Array.isArray(this.error.Commentators)) {
        this.error.Commentators = this.error.Commentators.filter((item) => item !== this.user.UserId);
      } else {
        this.error.Commentators = [];
      }
    },
  },
};
